import { FC, useContext } from "react";
import NotificationDispatch, { showErrorNotification } from "../../context/notificationContext";
import useI18n from "../../hooks/useTranslations";
import { ProjectStatus, SearchProject } from "../../http/types/projects";
import { useProjectsApi } from "../../http/useProjects";
import InlineBadgeEditor from "../ui/InlineBadgeEditor";

interface EditProjectStatusProps {
  project: SearchProject;
  stati: ProjectStatus[];
  onUpdate: (status: string) => void;
}

const EditProjectStatus: FC<EditProjectStatusProps> = ({ project, stati, onUpdate }) => {
  const i18n = useI18n();
  const dispatch = useContext(NotificationDispatch);
  const projectsApi = useProjectsApi();

  const updateStatus = (status: string) => {
    projectsApi
      .updateProjectStatus(project.id, status)
      .then(() => onUpdate(status))
      .catch((err) => dispatch(showErrorNotification(i18n, err)));
  };

  const options = stati.map((status) => ({ value: status.value, label: status.display, color: status.color }));

  return <InlineBadgeEditor value={project.status} options={options} onChange={updateStatus} />;
};

export default EditProjectStatus;
